import styled from "styled-components";
import { Skeleton } from "@mui/material";
import { Row } from "react-bootstrap";

import HeroBgImage from "../../image/simulation/sims-hero-background.png";

export const StyledHeroSec = styled.section`
  background: url(${HeroBgImage});
  background-size: contain;
  padding: 5rem 5rem;
  @media screen and (max-width: 992px) {
    padding: 2.5rem;
  }
`;

export const StyledSimsSec = styled.section`
  padding: 3rem 0;
  background-color: #fafbfc;
  h3 {
    color: var(--blue-color-dark);
    font-size: var(--font-size-xl);
    font-weight: 300;
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
      font-weight: 400;
    }
  }
`;

export const SelectFilterRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 360px);
  grid-column-gap: 20px;
  column-gap: 20px;
  justify-content: center;
  @media screen and (max-width: 1200px) {
    grid-template-columns: 360px;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 360px;
  }
  @media screen and (max-width: 375px) {
    grid-template-columns: 1fr;
  }
`;

export const HashtagFilterContainer = styled.div`
  p {
    color: var(--blue-color-dark);
    font-weight: 500;
    font-size: var(--font-size-lg);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-base);
    }
  }
`;

export const HashtagFilterWrapper = styled(Row)`
  justify-content: center;
  column-gap: 15px;
  grid-column-gap: 15px;
`;

export const HashtagLabel = styled.div`
  background: var(--blue-color-light);
  padding: 0.5rem 1rem;
  font-size: var(--font-size-md);
  color: var(--text-color-dark);
  border-radius: 30px;
  max-width: fit-content;
  transition: all 0.1s ease-in;
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 10px;
  justify-content: center;
  border: 0;
  & .close-mark {
    cursor: pointer;
    &:hover {
      transition: all 0.1s ease-in;
      color: var(--danger-color);
    }
  }
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-sm);
  }
`;

export const HashtagLabelSkeleton = styled(Skeleton)`
  border-radius: 30px;
`;
